import { NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { Data } from '@singularsystems/neo-core';
import { reaction } from 'mobx';
import EventMappingLookup from '../Models/EventMappingLookup';
import GenericEventMappingCriteria from '../Models/EventMappingSearchCriteria';
import RunInterceptionComponentVM from '../../../Common/Components/Interception/RunInterceptionComponentVM';
import AssignEventComponentVM from '../components/AssignEventComponentVM';
import { TextConstants } from '../../../Common/TextConstants';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import EventMappingUpdate from '../Models/EventMappingUpdate';
import StaticEventLookup from '../Models/StaticEventSearchModal/StaticEventLookup';
import CreateStaticEventCommand from '../../../Maintenance/StaticEvents/Models/Commands/CreateStaticEventCommand';
import ManageStaticEventComponentVM from '../../../Maintenance/StaticEvents/Components/ManageStaticEventComponentVM';

@NeoModel
export default class EventMappingVM extends Views.ViewModelBase {

    constructor(
        public eventApiClient = AppService.get(Types.ApiClients.EventMappingApiClient),
        public staticEventsApiClient = AppService.get(Types.ApiClients.StaticEventsApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {
        super(taskRunner);
    }

    public eventMappingUpdateList: EventMappingLookup[] = [];
    public genericEventMappingCriteria = new GenericEventMappingCriteria();
    public eventMappingUpdate = new EventMappingUpdate();
    public assignEventMappingVM = new AssignEventComponentVM();
    public runInterceptionVM = new RunInterceptionComponentVM();
    public manageStaticEventComponentVM = new ManageStaticEventComponentVM();
    public showAssignEventMappingComponent: boolean = false;

    public pageManager = new Data.PageManager(this.genericEventMappingCriteria, EventMappingLookup, this.eventApiClient.getPagedEventMappings, {
        pageSize: 10,
        sortBy: "staticEventName",
        sortAscending: true,
        fetchInitial: true,
        initialTaskRunner: this.taskRunner,
    });

    public async initialise() {
        reaction(() => this.genericEventMappingCriteria.searchCriteria, () => this.pageManager.refreshData(), {fireImmediately: false, delay: 650 });
    }

    public displayAssignEventMappingComponent() {
        this.showAssignEventMappingComponent = !this.showAssignEventMappingComponent;
    }


    public async clearSearch() {
        this.genericEventMappingCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public async backToEventMapping() {
        this.assignEventMappingVM.clearSearch();
        this.eventMappingUpdateList = [];
        this.genericEventMappingCriteria.meta.searchCriteria.value = "";
        await this.assignEventMappingVM.pageManager.refreshData();
        await this.pageManager.refreshData().finally(()=> {
            this.showAssignEventMappingComponent = !this.showAssignEventMappingComponent;
        });
    }

    public async closeEventModal (justSaved: boolean = false) {
        if (justSaved) {
            var result = new StaticEventLookup();
            result.set((await this.staticEventsApiClient.getEventLookupFromEventName(this.assignEventMappingVM.manageStaticEventComponentVM.managedStaticEvent.staticEventName!)).data);
            if (result.staticEventName !== null) {
                await this.assignEventMappingVM.clearSearch();
                this.assignEventMappingVM.pageManager.data.unshift(result);
                this.assignEventMappingVM.pageManager.data[0].selected = true;
                this.assignEventMappingVM.SelectGenericEvent(this.assignEventMappingVM.pageManager.data[0]);
            }
        }
        this.manageStaticEventComponentVM.managedStaticEvent = new StaticEventLookup();
        this.assignEventMappingVM.showAddNewEventModalInd = false;
    }

    public populateMappedObject(selectedEventMappingValues: EventMappingLookup) {
        var genericEventMappingAsJSObject = selectedEventMappingValues;
        var existingObject = this.eventMappingUpdateList.find(c => c.genericEventMappingID === genericEventMappingAsJSObject.genericEventMappingID);

        if (existingObject) {
            this.eventMappingUpdateList.remove(existingObject)
        }
        else {
            this.eventMappingUpdateList.push(genericEventMappingAsJSObject);
        }
    }

    public async saveNewEvent() {
        var command = this.mapEventToCreateCommand(this.assignEventMappingVM.manageStaticEventComponentVM.managedStaticEvent).toJSObject();
        var response = await this.taskRunner.run(() => this.staticEventsApiClient.createStaticEvent(command));
        if (response.data.success) {
            NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.EventSaved, NotificationDuration.Standard);
            this.assignEventMappingVM.showAddNewEventModalInd = false;
        }
        else {
            NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger", NotificationDuration.Long);
        }
        this.closeEventModal(true);
    }

    public async updateEventMapping() {
        this.assignEventMappingVM.clearSearch();
        this.eventMappingUpdate.selectedEvent = this.assignEventMappingVM.selectedEventMapping;
        this.eventMappingUpdate.eventMappings = this.eventMappingUpdateList;
        var response = await this.taskRunner.run(() => this.eventApiClient.updateEventMapping(this.eventMappingUpdate.toJSObject()));
        if (response.data.success) {
            NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulEventMappingUpdate, NotificationDuration.Standard);
            this.backToEventMapping();
        }
        else {
            NotifyUtils.add(TextConstants.Titles.Error, TextConstants.Notifications.FailedSubmission, "danger", NotificationDuration.Long);
        }
    }

    public async onAssignEventSearch() {
        await this.assignEventMappingVM.pageManager.refreshData();
    }

    private mapEventToCreateCommand(staticEventLookup: StaticEventLookup) {
        var command = new CreateStaticEventCommand().mapFrom(staticEventLookup);
        return command;
    }
}